module.exports = __webpack_public_path__ + "media/images/icons/twotone/appstore-98137aa7de032cfe29b664c3a167e4e7.svg";